export default __webpack_public_path__ + "static/butik_img3-8ad56155fc7868b3890bb5cc2ac1add2.png";